import { observer } from "mobx-react";
import * as React from "react";
import styled from "styled-components";
import { UserInfoContext } from "../../../WSUtils/UserInfoContext";
import { device } from "../../../WSUtils/constants/mediaQueries";
import { getUrlFromLogoParameters } from "../../../WSUtils/getUrlFromLogoParameters";
import { getRedirectProps } from "../../../WSUtils/urlUtils";
import { useLatestQuery } from "../../../WSUtils/useLatestQuery";
import { withWSErrorContainer } from "../../../WSUtils/withWSErrorContainer";
import { useLocStore } from "../../../wsLocalization";
import { LocContext } from "../../../wsLocalization/LocContext";
import { MobileMenu } from "../MobileMenu";
import { ProfileMenu } from "../ProfileMenu";

const TopBar: React.FC = withWSErrorContainer(
  observer(() => {
    const userInfo = React.useContext(UserInfoContext);
    const L = useLocStore(LocContext.GENERAL);

    const { data: whoAmi } = useLatestQuery(["authAPI.whoAmi"], () =>
      userInfo.fullAPI.authAPI.whoAmi({ includeUnitIds: false, userInfo })
    );

    const isLoggedInVisma = !!whoAmi?.hasVismaToken;
    const isLoggedInCvp = !!whoAmi?.hasCvpToken;

    return (
      <TopBarStyles className="cvp-app-top-bar">
        <StyledMenuLogoContainer className="cvp-menu-logo-container ">
          <MobileMenu />
          <div className="cvp-app-top-bar-logo-container">
            {!!userInfo.settings.logoPrimary && (
              <img
                src={getUrlFromLogoParameters(
                  userInfo.settings.logoPrimary,
                  userInfo.idConcern
                )}
                className="cvp-app-top-bar-logo"
              />
            )}
          </div>
        </StyledMenuLogoContainer>
        <StyledLogoutProfileContainer className="cvp-profile-container">
          <StyledLogOutBtn
            className={
              isLoggedInVisma ? "p-button-text loggedIn" : "p-button-text"
            }
            {...getRedirectProps(isLoggedInVisma ? "/logout" : "/login", {
              userInfo,
              mergeQs: null,
            })}
          >
            {!!isLoggedInVisma && L.id("55c552133c7f").loc("Logg ut")}
            {!isLoggedInVisma && L.id("a918c8de02b7").loc("Logg inn")}
          </StyledLogOutBtn>

          {isLoggedInVisma ? <ProfileMenu /> : ""}
        </StyledLogoutProfileContainer>
      </TopBarStyles>
    );
  })
);

export default TopBar;

export const StyledLogOutBtn = styled.a`
  &&&&& {
    &.loggedIn {
      display: none;

      @media ${device.lg} {
        display: block;
      }
    }
  }
`;

export const StyledMenuLogoContainer = styled.div`
  &.cvp-menu-logo-container {
    display: flex;
    align-items: center;
    column-gap: 0.5rem;

    .cvp-app-top-bar-logo-container {
      height: 2.5rem;
      display: flex;
      align-items: center;
      padding: 0.3rem;

      @media ${device.lg} {
        height: 3rem;
      }
    }

    .cvp-app-top-bar-logo {
      max-height: 100%;
    }
  }
`;

export const StyledLogoutProfileContainer = styled.div`
  &.cvp-profile-container {
    display: flex;
    align-items: center;
    column-gap: 1rem;
  }
`;

const TopBarStyles = styled.div`
  &.cvp-app-top-bar {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1100;

    display: flex;
    justify-content: space-between;
    align-items: center;
    background: var(--surface-a);
    padding: 0 1rem;
    height: 3rem;
    border-bottom: 1px solid var(--primary-100);

    .cvp-avatar-button {
      padding: 0;
    }

    .cvp-avatar {
      margin-left: 0.75rem;
      color: var(--primary-500);
      background-color: var(--primary-100);
    }
  }
`;
